/*
  Zugo - alt bilgi menu sutunlari.

  Masaustunde listeler her zaman aciktir; dugme yalnizca bir basliktir.
  Mobilde (<=767px) her sutun acilir-kapanir olur - Selin Beauty duzeni.

  Yukseklik CSS'ten sabit verilemez (kalem sayisi sutundan sutuna degisir),
  bu yuzden acilirken gercek yukseklik olculup `max-height`e yazilir. Gecis
  bitince `none`a cevrilir; boylece pencere yeniden boyutlanınca ya da yazi
  tipi gec yuklenince liste kirpilmaz.
*/
const MOBIL = '(max-width: 767.98px)';

class ZugoFooterCol extends HTMLElement {
  connectedCallback() {
    this.dugme = this.querySelector('.zugo-footer__col-dugme');
    this.liste = this.querySelector('.zugo-footer__liste');
    if (!this.dugme || !this.liste) return;

    this.sorgu = window.matchMedia(MOBIL);
    this.tikla = () => {
      if (!this.sorgu.matches) return;
      this.ayarla(this.getAttribute('aria-expanded') !== 'true');
    };
    this.olcuDegisti = () => this.moduUygula();

    this.dugme.addEventListener('click', this.tikla);
    this.sorgu.addEventListener('change', this.olcuDegisti);
    this.liste.addEventListener('transitionend', (e) => {
      if (e.propertyName === 'max-height' && this.getAttribute('aria-expanded') === 'true') {
        this.liste.style.maxHeight = 'none';
      }
    });

    this.moduUygula();
  }

  disconnectedCallback() {
    this.dugme?.removeEventListener('click', this.tikla);
    this.sorgu?.removeEventListener('change', this.olcuDegisti);
  }

  moduUygula() {
    if (this.sorgu.matches) {
      // Mobil: varsayilan kapali
      this.ayarla(false, true);
    } else {
      // Masaustu: her zaman acik, satir ici olcu temizlenir
      this.removeAttribute('aria-expanded');
      this.dugme.setAttribute('aria-expanded', 'true');
      this.liste.style.maxHeight = '';
    }
  }

  ayarla(acik, sessiz = false) {
    this.setAttribute('aria-expanded', acik ? 'true' : 'false');
    this.dugme.setAttribute('aria-expanded', acik ? 'true' : 'false');

    if (acik) {
      this.liste.style.maxHeight = `${this.liste.scrollHeight + 24}px`;
    } else {
      // Kapatirken once gercek yuksekligi yazip sonra sifirlamak gerekir,
      // yoksa `none` -> `0` gecisi animasyonsuz atlar.
      if (!sessiz && this.liste.style.maxHeight === 'none') {
        this.liste.style.maxHeight = `${this.liste.scrollHeight}px`;
        void this.liste.offsetHeight;
      }
      this.liste.style.maxHeight = '0px';
    }
  }
}

if (!customElements.get('zugo-footer-col')) {
  customElements.define('zugo-footer-col', ZugoFooterCol);
}
